import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/page-header';
import { usePerformanceReviewAccess } from '../hooks';

/**
 * Review editor. Placeholder shell wired to the route in this story; the form
 * and publish flow land with the editor story.
 */
const PerformanceReviewEdit: React.FC = () => {
  const { t } = useTranslation('performanceReview');
  const canView = usePerformanceReviewAccess();

  if (!canView) {
    return null;
  }

  return (
    <div>
      <PageHeader title={t('form.title')} testId="performance-review-edit" />
    </div>
  );
};

export default PerformanceReviewEdit;
